module Elma.Bindings {

    export interface IUpdateInputViaSelect {
        target: KnockoutObservable<string>
    }

    export class UpdateInputViaSelect {

        public init(element: HTMLSelectElement, valueAccessor: () => IUpdateInputViaSelect, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {

            if (!bindingContext)

                return;

            var value = valueAccessor();



            ko.utils.registerEventHandler(element, "change", function () {
                var currentValue = element.value;
                if (currentValue) {
                    value.target(currentValue);
                }
            });

        }

    }

    ko.bindingHandlers['updateInputViaSelect'] = new UpdateInputViaSelect();

}